import type { TError } from '@onesource/schemas';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';
import type { TReviewMissingParams } from './use-review-missing';
import { toReviewSearchParams, type TReviewQueueParams } from './use-review-queue';

/** What the page shows: a submissions tile, or Not submitted. Paging is left out — the export is every page. */
export type TReviewExportParams =
  | ({ view: 'submissions' } & Omit<TReviewQueueParams, 'page' | 'perPage'>)
  | ({ view: 'not_submitted' } & Omit<TReviewMissingParams, 'page' | 'perPage'>);

/** Download the review list as the server renders it, under the given file name. */
export const useDownloadReviewExport = (spaceId: string) =>
  useMutation<void, TError, { params: TReviewExportParams; filename: string }>({
    mutationFn: async ({ params, filename }) => {
      const { data } = await axios.get<Blob>(`/community-hub/spaces/${spaceId}/review/export`, {
        params: toReviewSearchParams(params),
        responseType: 'blob',
      });
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.csv`;
      document.body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    },
  });
